import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    loading: false,
    show: true,
    region: [],
    displayInfo: JSON.parse(localStorage.getItem('displayInfo')||'{"name": ""}'),
    templateInfo: null,
    flowCount: null,
    suggestMap: {},
    flow:null,
    collapsed: localStorage.getItem('collapsed') === 'true',
    companyInfo: JSON.parse(localStorage.getItem('companyInfo')||'{}'),
  },
  mutations: {
    CLEAR(state) {
      state.loading = false;
      state.show = true;
      state.region = [];
      state.displayInfo = {};
      state.templateInfo = null;
      state.flowCount = null;
      state.suggestMap = {};
      state.companyInfo = {};
    },
    SET_LOADING (state, res) {
      state.loading = res;
    },
    SET_IS_COLLAPSE (state, res) {
      localStorage.setItem('collapsed',String(res))
      state.collapsed = res;
    },
    SET_DISPLAY_INFO (state, res) {
      localStorage.setItem('displayInfo',JSON.stringify(res))
      state.displayInfo = res;
    },
    SET_COMPANY_INFO (state, res) {
      localStorage.setItem('companyInfo',JSON.stringify(res))
      state.companyInfo = res;
    },
    SET_TEMPLATE_INFO (state, res) {
      state.templateInfo = res;
    },
    SET_FLOW_COUNT (state, res) {
      state.flowCount = res;
    },
    SET_SUGGEST_MAP (state, res) {
      // @ts-ignore
      state.suggestMap[res.key] = res.value;
    },
    DELETE_SUGGEST_MAP (state, key) {
      // @ts-ignore
      delete state.suggestMap[key];
    },
    SET_SHOW (state, res) {
      state.show = res;
    },
    REFRESH (state, vue) {
      state.show = false;
      vue.$nextTick(() => (state.show = true));
    },
    SET_FLOW (state, res) {
      state.flow = res;
    },
  },
  actions: {
  },
  modules: {
  },
});
